<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition"
       [ngClass]="{'-is-open -extra-width' : customerOverviewService.listOfModals.editCustomerModalOpened,
                  '-is-closed': !customerOverviewService.listOfModals.editCustomerModalOpened}">

  <div class="esf-main-sidebar__content">
    <ng-container [ngSwitch]="customer.isCompany">
      <h3 *ngSwitchCase="false" i18n='Customer data edit modal title@@customerOverviewComponent.modalTitle.editCustomerData'>Edit customer data</h3>
      <h3 *ngSwitchCase="true" i18n='Customer data edit modal title@@customerOverviewComponent.modalTitle.editCompanyData'>Edit company data</h3>
    </ng-container>
    <form [formGroup]="updateCustomerForm" (ngSubmit)="updateFormSubmit(updateCustomerForm)" id="updateCustomerForm">
      <div class="esf-form-item">
        <button type="button" class="esf-button esf-button--simple" [disabled]="!customer.isEditable" (click)="toggleCustomerType()">
          <ng-container [ngSwitch]="customer.isCompany">

            <ng-container *ngSwitchCase="true">
              <svg class="esf-icon esf-button__icon" width="16" height="16">
                <use xlink:href="#esf-icon-user-small"></use>
              </svg>
              <span class="esf-button__icon-text" i18n="@@customerOverview.button.changeToPrivate">Change to PRIVATE</span>
            </ng-container>

            <ng-container *ngSwitchCase="false">
              <svg class="esf-icon esf-button__icon" width="16" height="16">
                <use xlink:href="#esf-icon-suitcase-16"></use>
              </svg>
              <span class="esf-button__icon-text" i18n="@@customerOverview.button.changeToCompany">Change to COMPANY</span>
            </ng-container>

          </ng-container>
        </button>
      </div>

      <div class="esf-form-group">
        <div class="esf-form-item esf-form-item--1-2">
          <label class="esf-form-item__label" for="salutation">{{ flTranslations.i18nSalutation }}<app-optional *ngIf="customer.isCompany"></app-optional></label>
          <div class="name-prefix-wrapper">
            <div class="esf-check-radio">
              <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="salutation" type="radio" id="pmr" value="mr">
              <label class="esf-check-radio__label esf-check-radio--radio__label" for="pmr" i18n='Form label text@@general.formLabel.Mr'>Mr.</label>
            </div>
            <div class="esf-check-radio">
              <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="salutation" type="radio" id="pmrs" value="mrs">
              <label class="esf-check-radio__label esf-check-radio--radio__label" for="pmrs" i18n='Form label text@@general.formLabel.Mrs'>Mrs.</label>
            </div>
            <div class="esf-check-radio">
              <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="salutation"
                     type="radio" id="notSpecified" [value]='null'>
              <label class="esf-check-radio__label esf-check-radio--radio__label" for="notSpecified" i18n='Form label text@@general.formLabel.notSpecified'>Not specified</label>
            </div>
          </div>
        </div>
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [control]="updateCustomerForm.get('title')"
             [optional]="true"
             [placeholder]="flTranslations.i18nTitle"
             [label]="flTranslations.i18nTitle">
        </div>
      </div>

      <div class="esf-form-group">
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [optional]="customer.isCompany"
             [control]="updateCustomerForm.get('firstName')"
             [placeholder]="flTranslations.i18nFirstName"
             [label]="flTranslations.i18nFirstName">
        </div>
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [optional]="customer.isCompany"
             [control]="updateCustomerForm.get('lastName')"
             [placeholder]="flTranslations.i18nLastName"
             [label]="flTranslations.i18nLastName">
        </div>
      </div>
      <div app-form-field-text-generic
           [optional]="customer.isPerson"
           [control]="updateCustomerForm.get('company')"
           [placeholder]="flTranslations.i18nCompany"
           [label]="flTranslations.i18nCompany">
      </div>
      <div app-form-field-datepicker
           [optional]="true"
           [past]="true"
           [control]="updateCustomerForm.get('birthday')"
           [placeholder]="flTranslations.i18nBirthday"
           [label]="flTranslations.i18nBirthday">
      </div>
      <div app-form-field-text-generic
           [control]="updateCustomerForm.get('externalAuthorization')"
           [placeholder]="flTranslations.i18nNoAuthorization"
           [label]="flTranslations.i18nAuthorization">
      </div>
    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition" [ngClass]="{'-is-open -extra-width': customerOverviewService.listOfModals.editCustomerModalOpened}">
  <app-submit-row-buttons [form]="'updateCustomerForm'"
                          [isFieldValid]="customer.isEditable"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="customerOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space  -has-transition"
     (click)="customerOverviewService.toggleAllModal(false)"
     [ngClass]="{'-is-open': customerOverviewService.listOfModals.editCustomerModalOpened}">
  <span class="esf-hamburger__icon"></span>
</div>
